import { render, staticRenderFns } from "./MaterialOnlineOrReturn.vue?vue&type=template&id=52ed3026&scoped=true&"
import script from "./MaterialOnlineOrReturn.vue?vue&type=script&lang=js&"
export * from "./MaterialOnlineOrReturn.vue?vue&type=script&lang=js&"
import style0 from "./MaterialOnlineOrReturn.vue?vue&type=style&index=0&id=52ed3026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ed3026",
  null
  
)

export default component.exports